export const API_KEY = "0d9c86934cdee15b91618e8ead8a4c49";
export const API_BASE_URL = import.meta.dev
  ? "/api/erg"
  : "https://erg-api-v2-qa-110547846370.europe-west1.run.app";
